<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{ this.dlgTitle }}</span>
      <button
        mat-icon-button
        class="mat-icon-button white-fg"
        (click)="dialogRef.close()"
        aria-label="Close dialog"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-toolbar>
  <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar>
    <form class="addDialog" [formGroup]="form" fxLayout="column" fxFlex>
      <mat-form-field>
        <mat-label>Context</mat-label>
        <mat-select
          class="form-control"
          multiple
          formControlName="context"
          name="context"
          (selectionChange)="contextChange($event)"
          aria-label="Filter Context"
          required
          [setFocus]="true"
        >
          <mat-option
            *ngFor="let item of contextGeneral"
            [value]="item.id"
            [ngStyle]="{
              'border-bottom': item.id === -2 ? '1px solid' : '0px'
            }"
            style="border-color: lightgray"
          >
            {{ item.name }}
          </mat-option>
          <mat-option *ngFor="let item of contextUsers" [value]="item.id">
            {{ item.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <validation-errors
        class="pt-8"
        [control]="form.get('context')"
      ></validation-errors>

      <mat-form-field>
        <mat-label>Type</mat-label>
        <mat-select
          class="form-control"
          formControlName="typeId"
          name="type"
          (selectionChange)="subjectTypeChange($event)"
          aria-label="filter subject type"
          required
        >
          <mat-option *ngFor="let item of sTypes" [value]="item.id">
            {{ item.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <validation-errors
        class="pt-8"
        [control]="form.get('typeId')"
      ></validation-errors>

      
      <mat-form-field *ngIf="showOrganisations && hasOrganisation">
        <mat-label>{{organisationLabel}}</mat-label>
        <mat-select class="form-control" formControlName="organisationId"
          name="organisation" (selectionChange)="selectionChange($event)" [disabled]="organisaitonReadonly"
          [required]="showOrganisations && hasOrganisation">
          <mat-option *ngFor="let item of organisations" [value]="item.id">
            {{item.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <validation-errors *ngIf="showOrganisations && hasOrganisation" class="pt-8" [control]="form.get('organisationId')"></validation-errors>


      <mat-form-field>
        <mat-label>Scope</mat-label>
        <mat-select
          class="form-control"
          formControlName="filterId"
          name="filter"
          aria-label="Time Scope"
          required
          (selectionChange)="markFilterAsChanged()"
        >
          <mat-option *ngFor="let item of filters" [value]="item.id">{{
            item.name
          }}</mat-option>
        </mat-select>
      </mat-form-field>
      <validation-errors
        class="pt-8"
        [control]="form.get('filterId')"
      ></validation-errors>

      <mat-form-field>
        <mat-label>Title</mat-label>
        <input
          matInput
          name="title"
          aria-label="Title"
          formControlName="title"
          maxlength="{{ titleMaxLength }}"
          (input)="markTitleAsChanged()"
        />
      </mat-form-field>

      <mat-form-field>
        <mat-label>Label</mat-label>
        <input
          matInput
          name="label"
          formControlName="label"
          aria-label="label"
          maxlength="{{ labelMaxLength }}"
          (input)="markLabelAsChanged()"
        />
      </mat-form-field>

      <div fxLayout="row" fxLayoutAlign="start center" class="ml-8 mt-16">
        <h4 class="mr-8" aria-label="Colour Selection">Colour</h4>
        <fuse-material-color-picker
          [(selectedBg)]="color"
          (selectedBgChange)="onColorChange($event)"
        >
        </fuse-material-color-picker>
      </div>
    </form>
  </div>

  <div
    mat-dialog-actions
    class="m-0 p-24"
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <div>
      <button
        mat-raised-button
        type="submit"
        [disabled]="!form.valid || form.pristine"
        [mat-dialog-close]="1"
        (click)="save()"
        class="save-button mat-accent"
        aria-label="SAVE"
      >
        SAVE
      </button>
    </div>
  </div>
</div>
